import actions from './actions';
import mutations from './mutations';

const state = {
  loadingBulkUpdate: false,
  loadingSendEmail: false,
  loadingSendTestEmail: false,
  selectedConfig: {},
  changedSelectedConfig: {},
  totalRegistrants: 0
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
